function computeOrderTotal(order) {
    let total = 0;

    let lists = order.list.slice();

    if (order.appends) {
        order.appends.forEach(ap => lists = lists.concat(ap.list));
    }

    lists.forEach((item) => {
        if (!item.available) return;

        if (item.weight_flag == 2) {
            // fixed_weight = fixed_price
            // total_weight = total_price

            // total_price = total_weight * fixed_price / fixed_weight

            total += item.total_weight * item.price / item.weight;
        } else {
            let itemPrice = item.price;

            if (item.modificators) item.modificators.forEach(mod => itemPrice += mod.price);

            total += itemPrice * item.quantity;
        }
    });

    if (order.discount && order.discount > 0) {
        // total = total * (total percent with discount)
        // total = total, rounded to 2 decimal digits
        // total = total in range(0,infinity)
        total = total * ((100 - order.discount) / 100);
        total = Math.round(total * 100) / 100;

        if (total < 0) total = 0;
    }

    return Math.round(total);
}

export default {
    computeOrderTotal
}